import { ButtonHTMLAttributes, PropsWithChildren } from "react"
import "./button.css"
import styled from "styled-components"

export const EditIcon = <img src="/assets/edit.svg" alt="edit" />
export const DeleteIcon = <img src="/assets/delete.svg" alt="edit" />
export const PlusIcon = <img src="/assets/plus.svg" alt="plus" />
export const UserIcon = <img src="/assets/user.svg" alt="user" />

const StyledHoverButton = styled.button`
  transition: all 0.3s ease;
  border-radius: 50%;

  &:hover {
    background: var(--btn-hover);
  }
`

export const IconButton = ({
  children,
  ...props
}: PropsWithChildren & ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <StyledHoverButton className="btn-icon" {...props}>
      {children}
    </StyledHoverButton>
  )
}
